module.exports = __webpack_public_path__ + "img/campaignpilot-campaign-sale.26aa948d.png";